import { Injectable } from '@odinjs/odin';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { APPLICATION_ENDPOINTS } from '../constants/application-endpoints';

import AllParameter from '../interfaces/dtos/allparameter-dto';

export interface PatientEntry {
  patientDateOfBirth: Date;
  patientName: string;
}

export interface TestPatientEntity {
  fullName: string;
  patientId: string;
}

export interface TestExams {
  examId: string;
  prodecureName: string;
}

@Injectable({})
export default class PatientDataService {

  public getPatientInfo(patientId: string): Promise<TestPatientEntity> {
    return HttpService.post(APPLICATION_ENDPOINTS.TEST_GET_PATIENT_INFO, { patientId }, {}).then(r => r.body as TestPatientEntity);
  }

  public getPatientExams(patientId: string): Promise<[TestExams]> {
    return HttpService.post(APPLICATION_ENDPOINTS.TEST_GET_PATIENT_EXAMS, { patientId }, {}).then(r => r.body as [TestExams]);
  }

  static getAllParameters(): Promise<AllParameter> {
    return HttpService.get(APPLICATION_ENDPOINTS.ALLPPARAMETER_URL, {}).then(response => response.body as AllParameter);
  }
}